import type { SortItem } from "@/application/composables/usePaginatedResourceList";

export default function toSortParam(sortBy: SortItem[]): string | undefined {
  const item = sortBy[0];
  if (!item) return undefined;

  return `${item.key},${item.order === "desc" ? "desc" : "asc"}`;
}
